import { getProcessData } from 'src/actions/processActions';

export const RECEIVE_PROCESS_VIEW = 'receive_process_view';
export const REQUEST_PROCESS_VIEW = 'request_process_view';
export const PROCESS_VIEW_ERROR = 'process_view_error';

const getActiveStateRedux =
	(modelId, guid, revision = '') =>
	async (dispatch) => {
		const onRequest = () => {
			// dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_PROCESS_VIEW,
			});
		};
		const onSuccess = (success) => {
			dispatch({
				// dipatch receive string and payload to be handled by reducer
				type: RECEIVE_PROCESS_VIEW,
				payload: success,
			});
			return success;
		};
		const onError = (error) => {
			dispatch({
				// dipatch error string and payload to be handled by reducer
				type: PROCESS_VIEW_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			// make api call
			const data = await getProcessData(modelId, guid, true, revision);
			return onSuccess(data);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};

export { getActiveStateRedux };
